import React, { useEffect, useImperativeHandle, useRef } from 'react';
import { useDrag } from 'react-dnd';
import { getEmptyImage } from 'react-dnd-html5-backend';
import styled from '@emotion/styled';

export const RECTANGLE = 'RECTANGLE';

interface DraggableRectangleProps {
  children: React.ReactNode;
}

export const DraggableRectangle = React.forwardRef<
HTMLDivElement,
DraggableRectangleProps
>(({ children }, ref) => {
  const rectangle = useRef<HTMLDivElement>(null);
  useImperativeHandle(ref, () => rectangle.current!);

  const [, drag, preview] = useDrag({ type: RECTANGLE });
  drag(rectangle);
  useEffect(() => {
    preview(getEmptyImage());
  }, []);

  return <Rectangle ref={rectangle}>{ children }</Rectangle>;
});

const Rectangle = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 1px solid rgba(0, 0, 0, 0.04);
  background: rgba(0, 0, 0, 0.2);
  cursor: move;
  pointer-events: initial;
`;
